import { useCallback, useRef } from "react"

const useAbortController = () => {
  const abortCtrlRef = useRef<AbortController | null>(null)

  const getAbortController = useCallback(() => {
    if (abortCtrlRef.current === null) abortCtrlRef.current = new AbortController()
    return abortCtrlRef.current
  }, [])

  const abort = useCallback((reason?: string) => {
    if (abortCtrlRef.current !== null) {
      abortCtrlRef.current.abort(reason ?? "Query aborted")
      abortCtrlRef.current = null
    }
  }, [])

  const getSignal = useCallback(() => getAbortController().signal, [getAbortController])

  return { getSignal, abort }
}

export default useAbortController
